// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1joxR","tabsBox":"styles_tabsBox__2WEw8","createButton":"styles_createButton__BKEpv"};